import React from "react";
import styled from "styled-components";
import ProgressRing from "@adsk/alloy-react-progress-ring";

const IssueCommentsLoaderContainer = styled.div`
  min-height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const IssueCommentsLoader = () => {
  return (
    <IssueCommentsLoaderContainer>
      <ProgressRing size={ProgressRing.SIZES.SMALL} />
    </IssueCommentsLoaderContainer>
  );
};
